/** @file Code-unit string order (locale-independent) so query output is deterministic everywhere. */

/** Negative when `a` sorts before `b` by UTF-16 code units (names are ASCII); 0 when equal. */
export function compareText(a: string, b: string): number {
  if (a === b) return 0;
  return a < b ? -1 : 1;
}
